import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CustomCard from "./CustomCard";
import data from "../data.json";

const useStyles = makeStyles({
  root: {
    flexGrow: 2,
    display: "flex",
    width: "100vw",
    background: "#F4f4f4",
    paddingTop: "100px",
  },
});

export default function GridView() {
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.root}
      justify="center"
      alignItems="center"
    >
      {data.secondaries.map((secondary) => {
        return <CustomCard {...secondary} />;
      })}
    </Grid>
  );
}
